import { useEffect, useState } from "react";
import axios from 'axios'

/* eslint eqeqeq: "off" */

const Confirm = (props) => {

    //----variables----

    //hard coded
    const baseUrl = process.env.REACT_APP_BASE_TICKETINO_URL;
    const baseProxyUrl = process.env.REACT_APP_PLUGIN_PROXY;
    const orderId = props.orderId;
    const token = props.token;
    const eventId = props.eventId;
    const changeLanguage = props.changeLanguage;
    const selectedLanguage = props.languageISO;
    const organizerId = props.organizerId

    const [resources, setResources] = useState([]);

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;

        scrollView();
    }, []);

    useEffect(() => {
        requestResources(selectedLanguage);
    }, [selectedLanguage]);

    const requestResources = async (langauge) => {
        await axios
            .get(`${baseProxyUrl}/resources/${langauge}`)
            .then((res) => {
                setResources(res.data);
            })
            .catch((error) => console.error(error.response.data));
    };

    const scrollView = () => {
        var scrollElement = document.getElementById("ticketinoScrollElement");

        if (scrollElement) {
            scrollElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    }

    //change the user selected langauge
    const updateLanguage = (language) => {
        requestResources(language);
        changeLanguage(language)
    }

    const requestReceipt = async () => {

        await axios.get(`${baseProxyUrl}/Order/${orderId}/Receipt?organizerId=${organizerId}`,
            { responseType: "blob" }
        ).then((res) => {
            const data = window.URL.createObjectURL(res.data);
            var link = document.createElement("a");
            link.href = data;
            link.download = "Receipt.pdf";
            link.click();
        }).catch((error) => console.error(error.response.data));
    }

    const requestTicket = async () => {
        await axios.get(`${baseProxyUrl}/Order/${orderId}/Tickets?organizerId=${organizerId}`,
            { responseType: "blob" }
        ).then((res) => {
            const data = window.URL.createObjectURL(res.data);
            var link = document.createElement("a");
            link.href = data;
            link.download = "Tickets.pdf";
            link.click();
        }).catch((error) => console.error(error.response.data));
    }

    const languageSelectDiv = () => {
        return (
            <div className="container">
                <div className="row justify-content-end">
                    <div className="col-auto">
                        <select
                            className="ticketinoSelect selectNum form-select"
                            aria-label=""
                            value={selectedLanguage}
                            onChange={(e) => {
                                updateLanguage(e.currentTarget.value);
                            }}>
                            <option value={"en"} key={1} >{"en"}</option>
                            <option value={"de"} key={2} >{"de"}</option>
                            <option value={"fr"} key={3} >{"fr"}</option>
                            <option value={"it"} key={4} >{"it"}</option>

                        </select>
                    </div>
                </div>
                <p className="ticketinoText text titleStyle text-start text-center fs-3 fw-semibold mb-2">{resources.confirmPage?.title}</p>
                <p className="ticketinoText text fs-6 text-center">{resources.confirmPage?.instruction}</p>
            </div>
        )
    }

    return (
        <div className="page-container">
            <div>
                {languageSelectDiv()}
                <div className="container text-center">
                    <button className="ticketinoButton btn mx-2 button btn-light" onClick={requestReceipt} >
                        {resources.confirmPage?.buttonLabelReceipt}
                    </button>
                    <button className="ticketinoButton btn mx-2 button btn-light" onClick={requestTicket} >
                        {resources.confirmPage?.buttonLabelTickets}
                    </button>
                </div>
            </div>
        </div>

    )
}

export default Confirm;